import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}
@Component({
    selector: 'app-send-medical-form',
    templateUrl: './send-medical-form.component.html',
    styleUrls: ['./send-medical-form.component.scss'],
    standalone: false
})
export class SendMedicalFormComponent implements OnInit {
  emailFormControl = new UntypedFormControl('', [
    Validators.required,
    Validators.pattern(/^[\d\w._-]+@[\d\w._-]+\.[\w]+$/i),
  ]);

  matcher = new MyErrorStateMatcher();

  constructor(
    public dialogRef: MatDialogRef<SendMedicalFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.emailFormControl.setValue(this.data['mail']);
    if (environment.kioskMode && window.external.ShowKeyboard) {
      window.external.ShowKeyboard();
    }
  }

  back() {
    this.dialogRef.close();
  }

  submit(){
    if (this.emailFormControl.valid) {
      this.dialogRef.close(this.emailFormControl.value);
    }
  }
}
